import { Toaster as Sonner, type ToasterProps } from "sonner"

function Toaster({ ...props }: ToasterProps) {
	return (
		<Sonner
			theme="light"
			position="bottom-center"
			duration={2600}
			closeButton={false}
			className="toaster group"
			toastOptions={{
				classNames: {
					toast:
						"group toast !rounded-[10px] !border-0 !bg-[#15151a] !px-5 !py-3 !text-sm !font-medium !text-white !shadow-[0_10px_30px_rgba(0,0,0,0.3)]",
					title: "!text-white",
					description: "!text-white/80",
				},
			}}
			{...props}
		/>
	)
}

export { Toaster }
